import { render } from "./ItemCategoryDialog.vue?vue&type=template&id=7e9256be"
import script from "./ItemCategoryDialog.vue?vue&type=script&lang=js"
export * from "./ItemCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__